module.exports = __webpack_public_path__ + "assets/img/empty-data.24eaa289.svg";